    <!-- Author: Siddhartha
      Date: 17/01/2020
    Issue Description: secondary nav change Emp. code-->

<template lang="html">
  <div class="main-container">
    <breadcrumb :list="breadcrumbList" />
     <div>
       <tl-header type="h1">
          <div class="main-header">Change Employee Code</div>
       </tl-header>
       <br>
       <toast-message :message="errmsg" type="error" :isToastEnable="toast"  @close ="(val) => toast = val"/>
     </div>
     <under-construction></under-construction>

     <div class="addflexispace">
        <tl-radio
          name="uploadMethod"
          label="Manual"
          id="manualUpload"
          value="manualUpload"
          v-model="uploadMethod"
        />
        <tl-radio
          name="uploadMethod"
          label="Bulk Upload"
          id="bulkUpload"
          value="bulkUpload"
          v-model="uploadMethod"
        />
    </div>

      <div class="margintop-32 bg-white no-border" v-if="uploadMethod == 'bulkUpload'">
        <div class="col-12 margintop-32">
          <download-button
            onclick="location.href='https://dev-opn-test1.s3.ap-south-1.amazonaws.com/paylief-bulk-upload-templates/Template-Locations.xlsx'"
          ></download-button>
        </div>
        <div class="col-12 margintop-16">
          <upload-file />
        </div>
      </div>
      <div v-else>
        <div class="customColumnGrid margin-t-l">
               <div>
                <tl-select
                    label="Paygroup"
                    labelText="name"
                    :value="paygroup"
                    :multiple="true"
                    :options="paygroupOptions"
                    @change="(val)=>paygroup = val"
                  />
              </div>
              <div>
                <tl-select
                  label="Criteria"
                  :v-model="criteria"
                  :options="criteriaOptions"
                  @change="(val) => {criteria = val;onSelectCriteria(val)}"
                />
              </div>
              <div v-if="subCriteriaLabel">
                <tl-select
                  :label="subCriteriaLabel"
                  labelText="name"
                  :v-model="subcriteria"
                  :multiple="true"
                  :options="subCriteriaList"
                  @change="(val)=>subcriteria = val"
                />
              </div>

              <div>
                <btn text="Apply Filters" type="secondary" class="btn-filter margin-top-15" @click="applyFilter"></btn>
              </div>
            </div>

            <div class="searchsort margin-top-30">
              <search-dropdown
                label="Select Employee"
                v-model="searchText"
                :employeeData="customEmpList"
                @getList="searchDataList($event)"
                @empselected="(emp)=>selectedEmp(emp)"
              />
            </div>

            <div v-if="customEmpList.length" class="margintop-32">
              <data-table :columns="columnNames" :tableData="customEmpList" :checkbox="false" :showinrow="true" :showedit="true" :showhistory="false" :showdelete="false" :withForm="false" @editStart="initEditStart">
                <template v-slot:rowcontent="slotprops">
                  <img class="sm-img" v-if="slotprops.value.column.key=='imgSrc'" :src="slotprops.value.record[slotprops.value.column.key]"/>
                  <p v-if="slotprops.value.column.key!='imgSrc'">{{slotprops.value.record[slotprops.value.column.key]}}</p>
                </template>
              </data-table>
            </div>
      </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";
import SearchDropdown from "@/components/TlSearchDropdown.vue";

export default {
  components: {
    SearchDropdown
  },

  data() {
    return {
      underDevelopment: true,
      filterData: {
        businessUnit: "",
        location: "",
        costCentre: "",
        designation: ""
      },
      showModal: false,
      toast: false,
      errmsg: "",
      searchText: "",
      paygroupOptions: [],
      subcriteria: [],
      paygroup: "",
      criteria: "",
      subCriteriaList: [],
      subCriteriaLabel: "",
      criteriaOptions: [
        "Band",
        "Cost Center",
        "Business Unit",
        "Grade",
        "Location"
      ],

      customEmpList: [
        {
          imgSrc: "",
          code: "1234",
          first_name: "XYZ",
          bu_name: "BU One",
          email_id: "abcd@test.in",
          location_name: "HYD"
        },
        {
          imgSrc: "",
          code: "1234",
          first_name: "XYZ",
          bu_name: "BU One",
          email_id: "abcd@test.in",
          location_name: "HYD"
        },
        {
          imgSrc: "",
          code: "1234",
          first_name: "XYZ",
          bu_name: "BU One",
          email_id: "abcd@test.in",
          location_name: "HYD"
        }
      ],
      employeeList: [],
      columnNames: [
        {
          label: "",
          key: "imgSrc"
        },
        {
          label: "Code",
          key: "code"
        },
        {
          label: "Name",
          key: "first_name"
        },
        {
          label: "Business Unit",
          key: "bu_name"
        },
        {
          label: "Email ID",
          key: "email_id"
        },
        {
          label: "Location",
          key: "location_name"
        }
      ],
      uploadMethod: "manualUpload",
      breadcrumbList: [
        {
          name: "Organisation",
          url: `/dashboard/${this.$route.params.entity_index}/organisation`
        },
        {
          name: "Change Employee Code",
          url: `/dashboard/${this.$route.params.entity_index}/organisation/`
        }
      ]
    };
  },

  mounted() {
    //console.log("New component mounted.");
    this.customEmpList = [
      {
        imgSrc: "",
        code: "1234",
        first_name: "XYZ",
        bu_name: "BU One",
        email_id: "abcd@test.in",
        location_name: "HYD"
      },
      {
        imgSrc: "",
        code: "1234",
        first_name: "XYZ",
        bu_name: "BU One",
        email_id: "abcd@test.in",
        location_name: "HYD"
      },
      {
        imgSrc: "",
        code: "1234",
        first_name: "XYZ",
        bu_name: "BU One",
        email_id: "abcd@test.in",
        location_name: "HYD"
      }
    ];
  },
  computed: {
    ...mapGetters({
      getLegalEntityId: "onboard/legal_entities/legal_entity_ID"
    }),
    ...mapState({
      orgId: state => state.onboard.organization.id
    }),
    leId() {
      if (this.$route.params.entity_index) {
        return this.getLegalEntityId(this.$route.params.entity_index);
      } else {
        return this.getLegalEntityId(0);
      }
    }
  },
  activated() {
    this.getPaygroups();
    this.customEmpList = [
      {
        imgSrc: "",
        code: "1234",
        first_name: "XYZ",
        bu_name: "BU One",
        email_id: "abcd@test.in",
        location_name: "HYD"
      },
      {
        imgSrc: "",
        code: "1234",
        first_name: "XYZ",
        bu_name: "BU One",
        email_id: "abcd@test.in",
        location_name: "HYD"
      },
      {
        imgSrc: "",
        code: "1234",
        first_name: "XYZ",
        bu_name: "BU One",
        email_id: "abcd@test.in",
        location_name: "HYD"
      }
    ];
  },

  methods: {
    ...mapActions({
      fetchEmployeeByName: "globalapi/globalemployees/fetchByName",
      fetchEmployees: "dashboard/payroll/reports/Reports/fetchAll",
      fetch_paygroups: "onboard/paygroup/fetchAll",
      fetch_locations: "onboard/locations/fetchAll",
      fetch_grades: "onboard/salary_grades/fetchAll",
      fetch_bands: "onboard/salary_bands/fetchAll",
      fetch_businessunits: "onboard/business_units/fetchAll",
      fetch_cost_center: "onboard/cost_centres/fetchAll",
      fetch_designation: "onboard/designations/fetchAll"
    }),

    routeToMainStep(main_step_name) {
      this.$router.push({
        path: `/dashboard/${this.$route.params.entity_index}/${main_step_name}`
      });
    },
    routeToSubStep(sub_step_name) {
      this.$router.push({
        path: `/dashboard/${this.$route.params.entity_index}/organisation/${sub_step_name}`
      });
    },

    applyFilter() {},

    onSelectCriteria(event) {
      if (event == "Location") {
        this.subCriteriaLabel = "Location";
        this.getLocations();
      } else if (event == "Cost Center") {
        this.subCriteriaLabel = "Cost Centre";
        this.getCostCenter();
      } else if (event == "Band") {
        this.subCriteriaLabel = "Band";
        this.getBands();
      } else if (event == "Grade") {
        this.subCriteriaLabel = "Grade";
        this.getGrades();
      } else if (event == "Business Unit") {
        this.subCriteriaLabel = "Business Unit";
        this.getBU();
      } else {
        this.subCriteriaLabel = "Sub Criteria";
        this.subCriteriaList = [];
      }
    },
    async getLocations() {
      try {
        let res = await this.fetch_locations(this.leId);
        if (res.data.status) {
          this.subCriteriaList = res.data.payload.data;
        }
      } catch (error) {
        //console.log(error);
      }
    },
    async getBands() {
      try {
        let res = await this.fetch_bands(this.leId);
        if (res.data.status) {
          this.subCriteriaList = res.data.payload.data;
        }
      } catch (error) {
        //console.log(error);
      }
    },
    async getPaygroups() {
      try {
        let res = await this.fetch_paygroups(this.leId);
        if (res.data.status) {
          this.paygroupOptions = res.data.payload.data;
        }
      } catch (error) {
        //console.log(error);
      }
    },
    async getBU() {
      try {
        let res = await this.fetch_businessunits(this.orgId);
        if (res.data.status) {
          this.subCriteriaList = res.data.payload.data;
        }
      } catch (error) {
        //console.log(error);
      }
    },
    async getCostCenter() {
      try {
        let res = await this.fetch_cost_center(this.leId);
        if (res.data.status) {
          this.subCriteriaList = res.data.payload.data;
        }
      } catch (error) {
        //console.log(error);
      }
    },
    async getGrades() {
      try {
        let res = await this.fetch_grades(this.leId);
        if (res.data.status) {
          this.subCriteriaList = res.data.payload.data;
        }
      } catch (error) {
        //console.log(error);
      }
    },

    async getEmployeesByApplyingFilter() {
      let obj = {
        le_id: this.leId,
        bands:
          this.criteria == "Band"
            ? this.subcriteria.map(item => {
                return item.id;
              })
            : [],
        bunits:
          this.criteria == "Business Unit"
            ? this.subcriteria.map(item => {
                return item.id;
              })
            : [],
        cost_centers:
          this.criteria == "Cost Center"
            ? this.subcriteria.map(item => {
                return item.id;
              })
            : [],
        locs:
          this.criteria == "Location"
            ? this.subcriteria.map(item => {
                return item.id;
              })
            : [],
        paygroups: this.paygroup.length
          ? this.paygroup.map(item => {
              return item.id;
            })
          : []
      };
      try {
        let res = await this.fetchEmployees(obj);
        if (res.data.payload) {
          this.employeeList = [];
          let dataArr = res.data.payload;

          for (let i = 0; i < dataArr.length; i++) {
            let empObj = dataArr[i];
            empObj.showDropDown = false;
            this.employeeList.push(empObj);
          }
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    async getPaygroups() {
      try {
        let res = await this.fetch_paygroups(this.leId);
        if (res.data.status) {
          this.paygroupOptions = res.data.payload.data;
        }
      } catch (error) {
        //console.log(error);
      }
    },

    searchDataList(val) {
      this.getEmployeesByName(val);
    },

    async initEditStart(record) {
      try {
        //console.log("initEditStart");
        this.showModal = true;
      } catch (err) {
        this.toast = true;
        this.errmsg = err.message;
      }
    },

    async getEmployeesByName(val) {
      try {
        let res = await this.fetchEmployeeByName(val);
        if (res.data.payload.data) {
          this.customEmpList = res.data.payload.data;
        }
      } catch (error) {
        //console.log("error:", error);
        this.toast = true;
        this.errmsg = error;
      }
    },

    back() {
      this.$router.go(-1);
    }
  }
};
</script>
<style scoped lang="scss">
@import "@/scss/components/margins.scss";

.main-header {
  color: #6d6d6d;
  margin-top: 25px;
  font-size: 16px;
}

.content-new {
  margin: 32px 0 0 32px;
  .errorr {
    border: 1px solid #e01717;
  }
  .errorMessage {
    color: #e01717;
    // padding-top: 1px
  }
}
.addflexispace {
  display: flex;
}

.customColumnGrid {
  display: grid;
  grid-template-columns: 15% 15% 15% 15% 15%;
  grid-row-gap: 15px;
  grid-column-gap: 20px;
}

.margin-top-15 {
  margin-top: 15px !important;
}

.margin-top-30 {
  margin-top: 15px !important;
}

.searchsort {
  display: flex;
  align-items: center;
  width: 100%;
  padding-right: 10px;
  .sorttext {
    text-align: center;
    line-height: 30px;
    color: #726f75;
    padding: 0px 0px 0px 10px;
    margin-left: auto;
  }
}
</style>
